import { render, staticRenderFns } from "./WidgetTopTerms.vue?vue&type=template&id=0188f666&scoped=true&"
import script from "./WidgetTopTerms.vue?vue&type=script&lang=js&"
export * from "./WidgetTopTerms.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTopTerms.vue?vue&type=style&index=0&id=0188f666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0188f666",
  null
  
)

export default component.exports